import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

const SwTooltip = ({
  content,
  placement = "top", // top, right, bottom, left
  children,
  className = "", // custom class name
  trigger = ["hover", "focus", "click"], // hover, focus, click
  ...rest
}) => {
  return (
    <OverlayTrigger
      placement={placement}
      trigger={trigger}
      overlay={
        <Tooltip className={`SwTooltip ${className}`} {...rest}>
          {content}
        </Tooltip>
      }
    >
      {children}
    </OverlayTrigger>
  );
};

export default SwTooltip;
